import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import {
  claimViewTpaConst,
  preAuthViewTpaConst,
} from '../../constants/crmConstants';
import BucketedDataCards from './TpaPrimaryFilterCards';
import DateComponentTpa from './dateComponent';

const BucketedTPA = (props: any): ReactElement => {
  const [showDatePicker] = useState(false);
  const { resetFilter, selectedTag, tpaTagListData } = props;
  const { isPreAuthView } = useSelector(
    (state: RootState): any => state?.selectedInPatientDetail || {},
  );

  return (
    <>
      <div>
        <DateComponentTpa showDateComponent={showDatePicker} />
        <BucketedDataCards
          bucketedData={
            tpaTagListData && Object?.keys(tpaTagListData).length
              ? tpaTagListData
              : isPreAuthView
              ? preAuthViewTpaConst
              : claimViewTpaConst
          }
          resetFilter={resetFilter}
          selectedTag={selectedTag}
        />
      </div>
    </>
  );
};

export default BucketedTPA;
